import React , { Component } from 'react';
import '../../resource/css/commons/breadcrumb.css'
import imgBanner from '../../resource/img/banner.png';
import bannerInicial from '../../resource/svg/bannerInicial.svg';
import { CONSTANTES } from '../../utils/Constantes';
class Breadcrumbs extends Component {
  state= {
   
  }
setLocalStorage = (key, value) => {
    localStorage.setItem(key, JSON.stringify(value));
  }
getLocalStorage = (key) =>{
        if(localStorage.hasOwnProperty(key)){
          const local = localStorage.getItem(key);
          return JSON.parse(local);
        }else{
          return {};
        }        
  }

onClick = (e) =>{
    console.log("ir default");
    this.props.irDefault();
}

irInicio = (e) => {
  this.setLocalStorage('location-search' , "?flujo="+!this.props.opciones.length>0?"#blankpage":this.props.opciones[0].path.replace('/','#'));
  const indexURL = window.location.href.indexOf(CONSTANTES.RUTA.basename);
  const urlRedirect = window.location.href.substring(0, indexURL);
  window.location.href = urlRedirect + CONSTANTES.RUTA.basename;
}
/*componentWillReceiveProps(nextProps) {
  console.log(nextProps);
    //if(this.state.accionActual != nextProps.accionActual)
        this.setState({opciones: nextProps.opciones,
                      accionActual: nextProps.accionActual,
                      accionDefault: nextProps.accionDefault
                     });
    
}*/
render=()=>{
let location = this.getLocalStorage('FLUJO').replace('#','/') ;
  return (
        <ul className="breadcrumb d-flex">
            <li><a  onClick={this.irInicio} style={{cursor:"pointer"}}>INICIO</a></li>                     
            { 
              (this.props.opciones ? this.props.opciones :[]).map((p,key) => {
                    if (p.path){
                        if(p.path == location){
                          return (<li key={key+'li'+p.nombre}><a href="#">{p.nombre}</a></li>);
                        }
                    }else {                      
                        return (p.submenu ? p.submenu :[]).map((s,keys) => {                        
                            if(s.path == location){
                                return (<>
                                      <li key={keys+'li'+s.nombre} ><a  style={{cursor:"pointer"}} onClick={this.onClick}>{s.nombre}</a></li>
                                      {
                                      (this.props.accionActual || this.props.accionDefault) &&
                                      (<li key={keys+'li'+'_'+s.nombre} ><a  style={{cursor:"pointer"}}>{this.props.accionActual || this.props.accionDefault}</a></li>)
                                      }
                                      </>);
                            }                                
                        })                      
                    }             
                })               
              }
            {/*
              (this.state.opciones ? this.state.opciones :[]).map((p,key) => {
                if(!p.path )
               return  (p.submenu ? p.submenu :[]).map((s,keys) => {                        
                  if(s.path == location){
                      return (
                            
                            <li key={keys+'li'+'_'+s.nombre} ><a style={{cursor:"pointer"}}>{this.state.accionActual || this.state.accionDefault}</a></li>
                      );
                  }else{ return null;}                                 
              })   
              })
            */}
        </ul>    
    );
  }
}

export default Breadcrumbs;